'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var _excluded = ["className", "value", "label"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 *
 * `StatisticsCard` displays a kind of quantity of a certain information.
 *
 */
var StatisticsCard = react.forwardRef(function (props, ref) {
  var styles = react.useMultiStyleConfig('StatisticsCard', _objectSpread({}, props));
  var _omitThemingProps = react.omitThemingProps(props);
  _omitThemingProps.className;
  var value = _omitThemingProps.value,
    label = _omitThemingProps.label,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  return /*#__PURE__*/React__namespace.createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, rest, {
    className: utils.cx('chakra-statistics-card', props.className),
    __css: styles.container
  }), /*#__PURE__*/React__namespace.createElement(react.chakra.span, {
    __css: styles.value
  }, value), /*#__PURE__*/React__namespace.createElement(react.chakra.span, {
    __css: styles.label
  }, label));
});
StatisticsCard.displayName = 'StatisticsCard';
exports.StatisticsCard = StatisticsCard;